import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, X } from 'lucide-react';

const TeamMember = ({ member, index }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.1 }}
        whileHover={{ y: -10 }}
        className="glass-card rounded-xl overflow-hidden hover:shadow-elegant-lg transition-all duration-300 cursor-pointer group"
        onClick={() => setShowModal(true)}
      >
        <div className="relative overflow-hidden">
          <img 
            src={member.image_url} 
            alt={member.name} 
            className="w-full h-64 object-cover group-hover:scale-110 transition duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-300"></div>
        </div>
        <div className="p-6 text-center">
          <h3 className="text-xl font-bold text-white mb-1">{member.name}</h3>
          <p className="text-orange-500 text-sm mb-3">{member.position}</p>
          <div className="flex justify-center space-x-3">
            {member.email && (
              <a href={`mailto:${member.email}`} className="text-gray-400 hover:text-orange-500 transition">
                <Mail size={16} />
              </a>
            )}
            {member.phone && (
              <a href={`tel:${member.phone}`} className="text-gray-400 hover:text-orange-500 transition">
                <Phone size={16} />
              </a>
            )}
            {member.facebook_url && (
              <a href={member.facebook_url} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition text-xs font-bold">
                f
              </a>
            )}
            {member.twitter_url && (
              <a href={member.twitter_url} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition text-xs font-bold">
                t
              </a>
            )}
            {member.instagram_url && (
              <a href={member.instagram_url} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition text-xs font-bold">
                ig
              </a>
            )}
          </div>
        </div>
      </motion.div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowModal(false)}>
          <div className="bg-dark-800 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-dark-700" onClick={(e) => e.stopPropagation()}>
            <div className="relative">
              <button 
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 z-10 bg-dark-700 p-2 rounded-full hover:bg-dark-600 transition"
              >
                <X size={20} className="text-white" />
              </button>
              <img 
                src={member.image_url} 
                alt={member.name} 
                className="w-full h-72 object-cover rounded-t-xl"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold text-white mb-1">{member.name}</h3>
              <p className="text-orange-500 font-medium mb-4">{member.position}</p>
              <p className="text-gray-400 leading-relaxed mb-6">{member.bio}</p>
              <div className="border-t border-dark-700 pt-4">
                <h4 className="text-white font-semibold mb-3">Contact Information</h4>
                <div className="space-y-2">
                  {member.email && (
                    <div className="flex items-center space-x-3 text-gray-400">
                      <Mail size={16} className="text-orange-500" />
                      <a href={`mailto:${member.email}`} className="hover:text-orange-500 transition">{member.email}</a>
                    </div>
                  )}
                  {member.phone && (
                    <div className="flex items-center space-x-3 text-gray-400">
                      <Phone size={16} className="text-orange-500" />
                      <a href={`tel:${member.phone}`} className="hover:text-orange-500 transition">{member.phone}</a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeamMember;